import {IndustryTypeList} from "./IndustryTypeList";
import {IndustryTypeEdit} from "./IndustryTypeEdit";
import {IndustryTypeCreate} from "./IndustryTypeCreate";

export default {
    list: IndustryTypeList,
    create: IndustryTypeCreate,
    edit: IndustryTypeEdit
};
